import alertLibrary from './alertLibrary';

export default {
	alertLibraryPage: alertLibrary
}
